import React from 'react';
import { ClientsTableContainer } from './ClientsTableContainer';

const ClientsTable: React.FC = () => {
    return <ClientsTableContainer />;
};

export { ClientsTable };
